import { useState } from "react";
import { Chip, PageHeader } from "@/components/common";
import MatchList from "@/components/MatchList";

export default function MatchesPage() {
  const [min, setMin] = useState(70);
  const [status, setStatus] = useState("");
  return (
    <>
      <PageHeader title="Matchmaking" testid="matches-title" subtitle="Active leads ↔ available properties. Buyer ↔ Sale, Tenant ↔ Rent, Seller/Landlord ↔ Purchase requirement." />
      <div className="mb-4 flex gap-2 overflow-x-auto scrollbar-none">
        {[90, 70, 50].map((n) => <Chip key={n} active={min === n} onClick={() => setMin(n)} testid={`matches-min-${n}`}>{n}%+</Chip>)}
        <Chip active={status === "shortlisted"} onClick={() => setStatus(status ? "" : "shortlisted")} testid="matches-shortlisted">Shortlisted</Chip>
      </div>
      <MatchList params={{ min_score: min, ...(status ? { status } : {}) }} />
    </>
  );
}
